import { Box } from '@mui/material';
import Image from 'next/image';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import type { AnalyticsType } from '@repo/segment/types';
import {
  EntityPlacementCtaTypeEnum,
  type MonetizableEnum,
} from '@repo/supergraph-schemas/marketplace/enums';
import type { CtaType, ImageType } from '@repo/supergraph-schemas/marketplace/types';

type Props = {
  ctaAnalytics: AnalyticsType;
  image?: ImageType;
  cta?: CtaType;
  displayName?: string;
  monetizable?: MonetizableEnum;
};

export const CtaImage = ({ ctaAnalytics, cta, displayName, image }: Props) => {
  if (!image?.source) return null;
  const imageComponent = (
    <Image
      src={image.source}
      alt={image?.alt || displayName || ''}
      width={200}
      height={200}
      style={{ height: '100%', width: '100%' }}
    />
  );
  return (
    <Box sx={{ width: '100%' }}>
      {cta ? (
        <CtaLink
          cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
          analyticsPayload={ctaAnalytics}
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={ctaAnalytics.monetizable}
        >
          {imageComponent}
        </CtaLink>
      ) : (
        imageComponent
      )}
    </Box>
  );
};
